module.exports = __webpack_public_path__ + "img/shipo-icon-log-activity.e221cf67.svg";